import $ from "cash-dom";
import {validate} from "../systems/validate";
import {format} from "../systems/format";

export const licensePlateInputComponent = (root, {defaultValue} = {}) => {
    const $root = $(root);
    const input = $root.find('input').get(0);
    input.value = defaultValue;
    input.setAttribute('placeholder', window.innerWidth >= 1024 ? 'BT    123AB' : 'BT  123AB');

    const parseValue = format.licensePlate;
    const formatValue = format.view.licensePlate;

    const onInput = () => {
        const value = parseValue(input);
        input.value = formatValue(value);
    };

    input.oninput = onInput;

    if (defaultValue)
        onInput();
};
